import { FC } from 'react';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import { Grid } from '@material-ui/core';
import {
  UpgradeLicenseForm,
  UpgradeLicenseFormProps,
  ACHForm,
  /*, PaymentDialogForm*/
} from 'components/Forms';
import { InvoiceSentDialog } from 'components/Dialogs';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const UpgradeLicense: FC<UpgradeLicenseFormProps> = observer(({ alowPlanSelection }) => {
  const classes = useStyles();
  const {
    upgradeLicenseStore: { step, paymentMethod },
  } = useStore();
  const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHED_KEY as string);
  return (
    <>
      <Grid container className={classes.container}>
        {/* <Logo /> */}
        {step === 'upgrade-form' ? <UpgradeLicenseForm alowPlanSelection={alowPlanSelection} /> : null}

        {/* {step === 'payment-dialog' ? <PaymentDialogForm /> : null} */}
        {step === 'payment-form' ? (
          <Elements stripe={stripe}>
            {paymentMethod === 'ach' ? <ACHForm /> : null}
            {paymentMethod === 'invoice' ? <InvoiceSentDialog /> : null}
          </Elements>
        ) : null}
      </Grid>
    </>
  );
});

export default UpgradeLicense;
